import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { parseISO } from 'date-fns';
import EventCalendar from '../calendar/EventCalendar';

// Adapts compliance deadlines to the generic EventCalendar's normalized event shape.
export default function ComplianceCalendar({ deadlines = [], typeLabels = {} }) {
  const navigate = useNavigate();

  const events = useMemo(() => (
    deadlines
      .filter((d) => d.due_at)
      .map((d) => ({
        id: d.id,
        date: typeof d.due_at === 'string' ? parseISO(d.due_at) : new Date(d.due_at),
        title: typeLabels[d.type] || d.type,
        subtitle: d.client_name || '',
        status: d.status, // overdue | due_soon | pending | completed (computed server-side)
        stage: d.workflow_status ? String(d.workflow_status).replace(/_/g, ' ') : null,
      }))
  ), [deadlines, typeLabels]);

  return (
    <EventCalendar
      events={events}
      nounSingular="obligation"
      onOpenFull={() => navigate('/compliance')}
      fullListLabel="Open in Full List"
    />
  );
}
